module.exports = __webpack_public_path__ + "img/endocrinology.d8891b8d.png";